<template>
    <div class="settings-users">

        <!-- Título / Breadcrumbs / Botões -->
        <mu-row justify-content="center" align-items="center">
            <mu-col span="6" sm="6" md="6" lg="6" xl="6">

                <!-- Título da página -->
                <mu-title color="secondary" textStrong="700">Usuários</mu-title>

                <!-- Breadcrumbs -->
                <mu-breadcrumbs divider="—">
                    <font-awesome-icon icon="chevron-right" slot="divider" class="icon-sm icon-margin-right"/>
                    <mu-breadcrumbs-item v-for="item in breadcrumbs" :key="item.text" :to="{ name: item.route }" :disabled="item.disabled">{{ item.text }}</mu-breadcrumbs-item>
                </mu-breadcrumbs>
            </mu-col>
            <mu-col span="6" sm="6" md="6" lg="6" xl="6">

                <!-- Submenu -->
                <mu-submenu :submenu="submenu"></mu-submenu>
            </mu-col>
        </mu-row>

        <!-- Busca de clientes -->
        <div class="search">
            <mu-form :model="filter">
                <mu-paper :z-depth="1">
                    <mu-row gutter>
                        <mu-col span="12" sm="12" md="3" lg="3" xl="3">
                            <mu-text-field v-model="filter.name" full-width @keyup.enter="filterLoad()" label="Nome"></mu-text-field>
                        </mu-col>
                        <mu-col span="12" sm="12" md="3" lg="3" xl="3">
                            <mu-text-field v-model="filter.email" full-width @keyup.enter="filterLoad()" label="E-mail"></mu-text-field>
                        </mu-col>
                        <mu-col span="12" sm="12" md="3" lg="3" xl="3">
                            <mu-select label="Tipo Cliente" v-model="filter.status" full-width>
                                <mu-option v-for="(option, key) in options.status" :key="key" :label="option.label" :value="option.value"></mu-option>
                            </mu-select>
                        </mu-col>
                        <mu-col span="12" sm="12" md="3" lg="3" xl="3">
                            <div class="padding-top">
                                <mu-button round color="secondary" @click="filterLoad()">
                                    <font-awesome-icon icon="search" class="icon-md icon-margin-left"/>
                                    Filtrar
                                </mu-button>
                                <mu-button round @click="filterClear()">
                                    <font-awesome-icon icon="times" class="icon-md icon-margin-left"/>
                                    Limpar
                                </mu-button>
                            </div>
                        </mu-col>
                    </mu-row>
                </mu-paper>
            </mu-form>
        </div>

        <!-- Listagem de usuários -->
        <div class="users" v-if="!users.loading">
            <mu-paper :z-depth="1">
                <!-- Listagem dos usuários desktop -->
                <mu-data-table :columns="users.columns" :data="users.list" @row-click="edit" v-if="viewport !== 'mobile'" class="mu-table-custom">
                    <template slot="empty">
                        <div class="box-table-empty">
                            Não foi encontrado registros de usuários
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <td>{{ scope.row.firstName }} {{ scope.row.lastName }}</td>
                        <td>{{ scope.row.email }}</td>
                        <td>{{ scope.row.userName }}</td>
                        <td class="is-center">
                            {{ getNamePermission(scope.row.permition) }}
                        </td>
                        <td class="is-center">
                            <mu-badge content="Inativo" v-if="scope.row.status == 'I'"></mu-badge>
                            <mu-badge content="Ativo" color="success" v-if="scope.row.status == 'A'"></mu-badge>
                        </td>
                    </template>
                </mu-data-table>

                <!-- Listagem de usuários mobile -->
                <mu-list textline="three-line" v-if="viewport === 'mobile'">
                    <span v-for="(item, key) in users.list" :key="key">
                        <mu-list-item button :to="{ name: 'app.settings.users.edit', params: { id: item.id } }">
                            <mu-list-item-content>
                                <mu-list-item-title>{{ item.firstName }} {{ item.lastName }}</mu-list-item-title>
                                <mu-list-item-sub-title>
                                    {{ item.email }} <br>
                                    <mu-badge content="Inativo" v-if="item.status == 'I'"></mu-badge>
                                    <mu-badge content="Ativo" color="success" v-if="item.status == 'A'"></mu-badge>
                                </mu-list-item-sub-title>
                            </mu-list-item-content>
                            <mu-list-item-action>
                                <font-awesome-icon icon="pen" class="icon-md icon-margin-left"/>
                            </mu-list-item-action>
                        </mu-list-item>
                        <mu-divider></mu-divider>
                    </span>
                </mu-list>
            </mu-paper>

            <!-- Paginação -->
            <mu-flex class="paginate" justify-content="center" v-if="users.paging.total > users.paging.size">
                <mu-pagination :total="users.paging.total" :page-count="5" :page-size="users.paging.size" :current.sync="users.paging.page" @change="load()"></mu-pagination>
            </mu-flex>
        </div>

        <!-- Loading -->
        <mu-loading text="Carregando a lista de usuários" v-if="users.loading"></mu-loading>

    </div>
</template>

<script>
    import UsersServices from '@/services/settings/users'

    export default {
        name: 'app-settings-users',
        data () {
            return {
                breadcrumbs: [
                    {
                        text: 'Configurações',
                        route: 'app.settings',
                        disabled: false
                    },
                    {
                        text: 'Usuários',
                        disabled: true
                    }
                ],
                submenu: [
                    {
                        name: 'Criar Usuário',
                        icon: 'plus',
                        route: 'app.settings.users.create',
                        color: 'primary',
                        textColor: null
                    }
                ],
                users: {
                    loading: false,
                    paging: {
                        page: 1,
                        size: 10,
                        total: 0
                    },
                    columns: [
                        { title: 'Nome', name: 'name' },
                        { title: 'E-mail', name: 'email' },
                        { title: 'Usuário', name: 'username' },
                        { title: 'Permissão', name: 'permition', align: 'center' },
                        { title: 'Status', name: 'status', align: 'center' }
                    ],
                    list: []
                },
                options: {
                    status: [
                        { value: '', label: 'Todos' },
                        { value: 'A', label: 'Ativos' },
                        { value: 'I', label: 'Inativos' }
                    ]
                },
                filter: {
                    name: '',
                    email: '',
                    status: ''
                }
            }
        },
        /**
         * Método responsável por chamar o load() logo após o componente ser criado
         */
        created () {
            this.load()
        },
        methods: {
            /**
             * Método que redireciona para edição do item, esse método é chamado em cada linha da listagem
             */
            edit (index, row, event) {
                this.$router.push({ name: 'app.settings.users.edit', params: { id: row.id } }).catch(err => { if (err) console.log(err.name || '') })
            },

            /**
             * Método responsável por carregar a listagem de palavras chaves
             */
            async load () {
                try {
                    this.users.loading = true

                    let params = {
                        page: this.users.paging.page
                    }

                    if (this.filter.name) {
                        params.name = this.filter.name
                    }

                    if (this.filter.email) {
                        params.email = this.filter.email
                    }

                    if (this.filter.status) {
                        params.status = this.filter.status
                    }

                    let result = await UsersServices.findAll(params)

                    if (result && result.status) {
                        this.users.paging.page = result.currentPage
                        this.users.paging.total = result.rowCount
                        this.users.list = result.results
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os dados.')
                } finally {
                    this.users.loading = false
                }
            },

            /**
             * Retorna o nome por extenso da permissão do usuário
             */
            getNamePermission (permition) {
                switch (permition) {
                case 'S':
                    return 'Super'
                case 'A':
                    return 'Administrador'
                case 'C':
                    return 'Comercial'
                case 'U':
                    return 'Usuário'
                default:
                    return ''
                }
            },

            filterLoad () {
                this.users.paging.page = 1
                this.load()
            },

            /**
             * Limpa os campos do filtro e refaz o load original
             */
            filterClear () {
                this.filter = {
                    name: '',
                    email: '',
                    status: ''
                }
                this.users.paging.page = 1
                this.users.paging.size = 10
                this.load()
            }
        },
        computed: {
            /**
             * Utilizado para verificar se o acesso é de desktop, table ou mobile
             */
            viewport () {
                return this.$currentViewport.label
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .search
        margin 20px 0

        .row
            .mu-input
                margin-bottom 0

        .mu-paper
            padding 10px 20px 20px 20px

        .padding-top
            padding-top 28px

    .users
        margin 20px 0

        .mu-list
            padding 0

        td
            cursor pointer

        .row
            margin 0 20px
            padding 15px 0

            .text-right
                text-align right

        .paginate
            padding 20px

        .mu-paper
            padding 0px

</style>
